import { render, staticRenderFns } from "./SelectCustomer.vue?vue&type=template&id=125722ff&"
import script from "./SelectCustomer.vue?vue&type=script&lang=ts&"
export * from "./SelectCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('125722ff')) {
      api.createRecord('125722ff', component.options)
    } else {
      api.reload('125722ff', component.options)
    }
    module.hot.accept("./SelectCustomer.vue?vue&type=template&id=125722ff&", function () {
      api.rerender('125722ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectCustomer.vue"
export default component.exports